import dynamic from 'next/dynamic'
import { PropertyRecordsIcon } from 'src/components/insights/icons/property-records'
import { InsightBuilderWidget } from 'src/types/insight-builder'
import preview from 'src/assets/images/widgets-previews/building-lot-location.png'

const BuildingLotAndLocation = dynamic(
  () => import('src/components/insights/property-records/building-lot-and-location'),
  { ssr: false }
)

export const BuildingLotAndLocationWidget: InsightBuilderWidget = {
  id: 'building-lot-and-location',
  name: 'Building, Lot & Location',
  type: 'Property Records',
  icon: PropertyRecordsIcon,
  component: BuildingLotAndLocation,
  supportedResultTypes: ['alphamap-location'],
  preview,
  minTier: 'entry',
}
